/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_VaultInputs */

const en_premium_vault = /** @type {(inputs: Premium_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Content Vault`)
};

const id_premium_vault = /** @type {(inputs: Premium_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Konten Premium`)
};

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const es_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const fr_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const de_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const ja_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const zh_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const ar_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const it_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const ru_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const pt_premium_vault = en_premium_vault;

/** @type {(inputs: Premium_VaultInputs) => LocalizedString} */
const ko_premium_vault = en_premium_vault;

/**
* | output |
* | --- |
* | "Premium Content Vault" |
*
* @param {Premium_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_vault = /** @type {((inputs?: Premium_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_vault(inputs)
	if (locale === "es") return es_premium_vault(inputs)
	if (locale === "fr") return fr_premium_vault(inputs)
	if (locale === "de") return de_premium_vault(inputs)
	if (locale === "ja") return ja_premium_vault(inputs)
	if (locale === "zh") return zh_premium_vault(inputs)
	if (locale === "ar") return ar_premium_vault(inputs)
	if (locale === "id") return id_premium_vault(inputs)
	if (locale === "it") return it_premium_vault(inputs)
	if (locale === "ru") return ru_premium_vault(inputs)
	if (locale === "pt") return pt_premium_vault(inputs)
	return ko_premium_vault(inputs)
});